const KEY = 'adminToken';

/**
 * Admin JWT: prefer sessionStorage (smaller XSS persistence window than localStorage).
 * Reads legacy localStorage once until cleared by login/logout.
 */
export function getAdminToken() {
  try {
    const fromSession = sessionStorage.getItem(KEY);
    if (fromSession) return fromSession;
    const legacy = localStorage.getItem(KEY);
    return legacy || null;
  } catch {
    return null;
  }
}

export function setAdminToken(token) {
  try {
    sessionStorage.setItem(KEY, token);
    localStorage.removeItem(KEY);
  } catch {
    localStorage.setItem(KEY, token);
  }
}

export function clearAdminToken() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/** Same-origin admin API calls: sends HttpOnly cookie + optional legacy Bearer. */
export function adminFetchInit(init = {}) {
  const incoming = init.headers && typeof init.headers === 'object' ? init.headers : {};
  const isFormData = typeof FormData !== 'undefined' && init.body instanceof FormData;
  const headers = isFormData
    ? { ...incoming }
    : { 'Content-Type': 'application/json', ...incoming };
  const t = getAdminToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  return {
    credentials: 'include',
    ...init,
    headers,
  };
}
